
import { defineComponent } from 'vue';
import {requestAction, requestGetter} from "../../utils/cef";

export default defineComponent({
  name: 'TitlebarComponent',
  props: {
    canMinimize: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isWindows: false,
      isDarwin: false,
    };
  },
  async beforeMount() {
    requestGetter("GET_OS", {}, (data: any) => {
        if (data.payload.os === "windows")
            this.isWindows = true;
        else if (data.payload.os === "darwin")
            this.isDarwin = true;
        else
            this.isDarwin = false; // This is temporary, until we have a proper Linux titlebar
    });
  },
  methods: {
    minimize() {
      requestAction("MINIMIZE_WINDOW", {}, undefined);
    },
    close() {
      requestAction("CLOSE_WINDOW", {}, undefined);
    },
  },
});
